import { Factory } from 'fishery';
import {
  CoverageItemType,
  DictionaryType,
  DictionaryResponseType,
} from './types';

export const coverageItemFactory = Factory.define<CoverageItemType>(
  ({ sequence }) => ({
    type: `coverage_type_${sequence}`,
    name: `Coverage Name ${sequence}`,
    shortDescription: `Short description ${sequence}`,
    longDescription: `This is a longer description for coverage item #${sequence}.`,
    requirement: null,
    coverageExclusions: null,
    coverageInclusions: null,
  })
);

export const getDictionaryResponseFactory =
  Factory.define<DictionaryResponseType>(({ transientParams }) => {
    const count = transientParams.count ?? 3;
    return {
      coverages: coverageItemFactory.buildList(count),
    };
  });

export const completedDictionaryResponseFactory =
  getDictionaryResponseFactory.transient({ completed: true });

export const dictionaryFactory = Factory.define<DictionaryType>(
  ({ transientParams }) => {
    const count = transientParams.count ?? 3;
    const items = coverageItemFactory.buildList(count);

    const coveragesRecord = items.reduce<Record<string, CoverageItemType>>(
      (acc, item) => {
        acc[item.type] = item;
        return acc;
      },
      {}
    );

    return { coverages: coveragesRecord };
  }
);
